<template>
  <PageHeader :showBreadcrumb="true" />
  <div class="row">
    <div class="col-md-12">
      <p>
        There are several reasons why an enrollee may be dissatisfied with a decision made by their health maintenance organization (HMO)
        or a bill received from their provider. You may file a complaint online using this system; a more detailed description of complaints
        and appeals can be found on the
        <a href="https://www.health.state.mn.us/facilities/insurance/managedcare/complaint/index.html" target="_blank">Managed Care Systems Website</a>.
      </p>

      <p>
        There are four types of complaints or appeals that the Minnesota Department of Health (MDH) can help you with, listed below.
        When you submit your complaint online, MDH will review the information you provide and can recommend the best option for you.
      </p>

      <ol>
        <li>
          <strong>External Appeal</strong>:
          You disagree with a coverage decision made by your HMO, and you have already filed an appeal with your HMO that was denied.
          External appeals are reviewed by an Independent Review Organization (IRO); the decision made by the IRO is final.
          External appeals must be filed within 6 months of the date your appeal with your HMO was denied.
        </li>

        <li>
          <strong>HMO Complaint</strong>:
          You disagree with a decision made by your HMO, or how you were treated. MDH will investigate your complaint.
          You do not need to file an appeal with your HMO before filing a complaint.
        </li>

        <li>
          <strong>No Surprises Act Complaint</strong>:
          The No Surprises Act, a federal law, may protect you from many types of surprise bills, including balance billing,
          or problems with a good faith estimate you received from a provider. These complaints may be about your health plan
          or a health care provider.
        </li>

        <li>
          <strong>Quality of Care Complaint</strong>:
          The Minnesota Department of Health reviews complaints about quality of care you received from your health plan or its contracted medical providers.
          Quality of care issues may involve concerns about a provider's knowledge or skill, behavior, attitude, diagnosis, and treatment.
          You will not receive the final resolution of this type of complaint.
        </li>
      </ol>
    </div>
  </div>
  <div class="container p-3 text-center">
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
          <h2 class="tx-col">File An External Appeal</h2>
          <Button size="lg" class="me-2" rounded raised label="Go to File an External Appeal" severity="primary" @click="router.push('/appealsAndComplaints/FileAnExternalAppeal');"/>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
          <h2 class="tx-col">File A Consumer Complaint</h2>
          <Button size="lg" class="me-2" rounded raised label="Go to File a Consumer Complaint" severity="primary" @click="router.push('/appealsAndComplaints/FileAConsumerComplaint');"/>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-12">
      <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
        <h2 class="tx-col">Check Status of an Appeal or Consumer Complaint</h2>
        <Button size="lg" class="me-2" rounded raised label="Check Status of an Appeal or Consumer Complaint" severity="primary" @click="router.push('/appealsAndComplaints/CheckStatusAppealComplaint');"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageHeader from "@/components/common/PageHeader.vue";
import router from "@/router/index.js";
import Button from 'primevue/button';
</script>

<style scoped>
.portal-box {
  height: 200px;
}
.tx-col {
  height: 75%;
}
</style>